<template>
	<div class="copy-container" @click="copy">
		<Tippy
			:content="$t('common_button_copy')"
			:options="tippyOptions"
			ref="tip"
		>
			<slot />
		</Tippy>
	</div>
</template>

<script>
import { Tippy } from '@/components/common'
import { copyToClipboard } from '@/helperMethods'

const defaultOptions = {
	placement: 'top',
	interactive: true,
}

export default {
	name: 'CopyToClipboard',
	components: { Tippy },
	props: {
		value: null,
		getValue: null,
		tippyProps: Object,
	},
	data() {
		return {
			tippyOptions: {
				...defaultOptions,
				...(this.tippyProps || {}),
			},
		}
	},
	emits: ['copied'],
	methods: {
		show() {
			this.$refs.tip.$el._tippy.show()
		},
		hide() {
			this.$refs.tip.$el._tippy.hide()
		},
		copy(e) {
			if (e.target.value) {
				e.target.setSelectionRange(0, e.target.value.length)
			}
			if (this.getValue) {
				copyToClipboard(this.getValue())
			} else {
				copyToClipboard(this.value)
			}
			this.$emit('copied', e)
			this.$alert.success(this.$t('common_confirmation_copied_nocheck'))
		},
	},
}
</script>

<style lang="scss" scoped>
@import 'src/sass/variables';

.copy-container {
	cursor: pointer;
}
</style>
